import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Form from "../common/Form";
import Fieldset from "../common/Fieldset";
import Files from "../common/Files";
import { FileComponentNames } from "../../constants/ComponentConstants";
import { getPropertyFilesComponentProps } from "../../components/common/FilesHelperUtil";
import TextInput from "../../components/common/TextInput";
import TextAreaInput from "../../components/common/TextAreaInput";
import DateInput from "../../components/common/DateInput";
import SelectInput from "../../components/common/SelectInput";
import NumberInput from "../../components/common/NumberInput";
import AutoComplete from "../../components/common/AutoComplete";
import Datalist from "../../components/common/Datalist";
import OKToggle from "../../components/common/OKToggle";
import Revert from "../../components/common/Revert";
import Row from "../../components/common/Row";
import Col from "../../components/common/Col";
import Table from "../../components/common/Table";
import LeafletMap from "../../components/common/map/LeafletMap";

import AdresFieldset from "./AdresFieldset";

const DemoForm = (props) => {
    const {
        model,
        originalModel,
        fileDownloadUrl,
        onChange,
        onSave,
        onClose,
        onDropFiles,
        onRemoveFile,
        errors,
        revertAll,
        hasUnsavedChanges,
        onGroupSizeSelect,
        okToggleValue,
        demoTableData,
        onPageChange,
        pageSize,
        totalPages,
        activePage
    } = props;

    const demoFilesMimeTypes = 'application/vnd.ms-excel,application/msexcel, application/x-excel, application/x-msexcel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, image/png, image/jpeg, image/jpeg, image/gif, image/tiff';
    const demoFilesExtensions = 'pdf, xls, xlsx, doc, docx, ppt, pptx, jpeg, jpg, gif, png, tiff';
    const demoFilesProps = getPropertyFilesComponentProps("Demo Files", FileComponentNames.DEMO, fileDownloadUrl, model.filesComponent, originalModel.filesComponent, false, onDropFiles, onRemoveFile, onChange, {
        mimeTypes: demoFilesMimeTypes,
        extensions: demoFilesExtensions
    });

    const tdStyle = { padding: "5px" };

    return (
        <Fragment>
            <LeafletMap long={'51.505'} lat={'-0.09'} />
            <Form name="demo"
                title={"Demo"}
                headerVisible
                isNotRequired
                leftButtonLabel={model.datumIndiening ? null : "Bewaren"}
                onLeftButtonClick={onSave}
                rightButtonLabel="Sluiten"
                onRightButtonClick={onClose}>
                <TextInput
                    name="textInput"
                    label="Een TextInput"
                    value={model.textInput}
                    originalValue={originalModel.textInput}
                    onChange={onChange}
                />
                <TextAreaInput
                    name="textArea"
                    label="Een TextArea"
                    value={model.textArea}
                    originalValue={originalModel.textArea}
                    onChange={onChange}
                />
                <DateInput
                    name="datumInput"
                    label="Een DatumInput"
                    size={6}
                    value={model.datumInput}
                    originalValue={originalModel.datumInput}
                    onChange={onChange} />
                <SelectInput
                    items={[
                        { label: "andere", value: "ANDERE" },
                        { label: "abc", value: "ABC" },
                        { label: "def", value: "DEF" },
                        { label: "ghi", value: "GHI" },
                        { label: "jkl", value: "JKL" }]}
                    size={6}
                    name="selectInput"
                    label="Een SelectInput"
                    value={model.selectInput}
                    originalValue={originalModel.selectInput}
                    onChange={onChange}
                />
                <AutoComplete
                    items={[
                        { label: "andere", value: "ANDERE" },
                        { label: "abc", value: "ABC" },
                        { label: "def", value: "DEF" },
                        { label: "ghi", value: "GHI" },
                        { label: "jkl", value: "JKL" }]}
                    size={6}
                    name="autoComplete"
                    label="Een AutoComplete"
                    value={model.autoComplete}
                    originalValue={originalModel.autoComplete}
                    onChange={onChange}
                />
                <Datalist
                    items={[
                        { label: "andere", value: "ANDERE" },
                        { label: "abc", value: "ABC" },
                        { label: "def", value: "DEF" },
                        { label: "ghi", value: "GHI" },
                        { label: "jkl", value: "JKL" }]}
                    size={6}
                    name="datalist"
                    label="Een Datalist"
                    value={model.datalist}
                    originalValue={originalModel.datalist}
                    onChange={onChange}
                />
                <NumberInput
                    label="Een NumberInput"
                    name="numberInput"
                    onChange={onChange}
                    value={model.numberInput}
                    originalValue={originalModel.numberInput}
                />
                <Row>
                    <Col size={4}>
                        <label>Nu gaat het vooruit?</label>
                    </Col>
                    <Col size={2}>
                        <OKToggle
                            kleurbalk
                            value={okToggleValue}
                            onChange={onGroupSizeSelect}
                            name="okToggle"
                        />
                    </Col>
                </Row>
                <div className="u-clear" style={{ margin: '20px 30px 0 30px' }}>
                    <div className="o-col-5">
                        <h6>Demo - {model.title}</h6>
                        <p>Welcome to the demo. This is a demo text. Look around. Welcome to the demo. This is a demo text. Look around. Welcome to the demo. This is a demo text. Look around.</p><br />
                    </div>
                    <div className="o-col-7">
                        <Files {...demoFilesProps} />
                    </div>
                </div>
            </Form>
            <Fieldset title="An Extra Fieldset Below The Form">
                The fieldset is placed inside the Fragment, no extra div around the Form and Fieldset
            </Fieldset>
            {!hasUnsavedChanges ||
                <Fieldset title="Revert All">
                    <Revert
                        onChange={revertAll}
                        standAlone
                        showWarning
                    />
                </Fieldset>}


            <Fieldset title="Table with paging">
                <Table
                    headers={["Name", "Role"]}
                    onPageChange={onPageChange}
                    activePage={activePage}
                    pageSize={pageSize}
                    totalPages={totalPages}
                >
                    {demoTableData.map((x, i) =>
                        <tr style={{ borderStyle: 'solid', borderWidth: "1px", borderColor: '#eeefef', height: '100%' }} key={i} height="80">
                            <td style={tdStyle}>{x.name}</td>
                            <td style={tdStyle}>{x.role}</td>
                        </tr>
                    )}
                </Table>
            </Fieldset>
            <AdresFieldset />
        </Fragment>);
};

DemoForm.propTypes = {
    model: PropTypes.object,
    originalModel: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    errors: PropTypes.object,
    onDropFiles: PropTypes.func.isRequired,
    onRemoveFile: PropTypes.func.isRequired,
    fileDownloadUrl: PropTypes.string.isRequired,
    templateDownloadUrl: PropTypes.string.isRequired,
    fileComponents: PropTypes.object,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    revertAll: PropTypes.func,
    hasUnsavedChanges: PropTypes.bool,
    onGroupSizeSelect: PropTypes.func,
    demoTableData: PropTypes.arrayOf(PropTypes.object),
    onPageChange: PropTypes.func,
    pageSize: PropTypes.number,
    totalPages: PropTypes.number,
    activePage: PropTypes.number,
	okToggleValue: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	])
};

export default DemoForm;
